
import { BrowserRouter as Router, Switch } from "react-router-dom";
import NoPage from "./pages/NoPage";
import LandingPage from "./pages/LandingPage";
import Enseignant from "./pages/Enseignant";

import Login from "./pages/connexion/Login";
import Register from "./pages/connexion/Register";

import MyProfil from "./pages/MyProfil";
import CreateProject from "./Components/CreateProject";
import Myproject from "./Components/Myproject";

import NavTab from "./Layouts/NavTab";
import Connection from "./Components/Connection";

import ForgetPassword from "./pages/connexion/ForgetPassword";
import ProjectDetails from "./Components/ProjectDetails";
import EditProfil from "./Components/EditProfil";

import PublicRouter from "./RoutageComonents/PublicRouter";
import PrivateRouter from "./RoutageComonents/PrivateRouter";

import Communities from "./Components/Communitites";
import CreatePublication from "./Components/CreatePublication";
import CommunityDetails from "./pages/CommunityDetails";
import UpdateProject from "./Components/UpdateProject";
import UpdatePublication from "./Components/UpdatePublication"; 
import About from "./Components/About";


function App() {


  return (

    <div className="App">



      <Router>

        <Switch>

          <PublicRouter exact={true} path="/" component={LandingPage} />
          <PublicRouter exact={true} path="/signup" component={Register} />

          <PublicRouter exact={true} path="/forgotPassword" component={ForgetPassword} />
          <PublicRouter exact={true} path="/university/:acronym" component={Enseignant} />
          <PublicRouter exact={true} path="/profil/:id" component={NavTab} />
          <PublicRouter exact={true} path="/en" component={Enseignant} />
          <PublicRouter exact={true} path="/signin" component={Login} />
          <PrivateRouter exact={false} path="/myprofil/:id" component={MyProfil} />
          <PrivateRouter exact={true} path="/createProject" component={CreateProject} />
          <PrivateRouter exact={true} path="/createPublication" component={CreatePublication} />
          <PrivateRouter exact={true} path="/connection/:id" component={Connection} />
          <PrivateRouter exact={true} path="/myproject/:id" component={Myproject} />
          <PrivateRouter exact={true} path="/projectdetails/:id" component={ProjectDetails} />
          <PrivateRouter exact={true} path="/communities/:id" component={Communities} />
          <PrivateRouter exact={true} path="/editprofil/:id" component={EditProfil} />
          <PrivateRouter exact={true} path="/communitydetails/:id" component={CommunityDetails} />
          <PrivateRouter exact={true} path="/updateProject/:id" component={UpdateProject} />
          <PrivateRouter exact={true} path="/updatePublication/:id" component={UpdatePublication} />
          <PrivateRouter exact={true} path="/about/:id" component={About} />
        </Switch>

      </Router>
      {/*}
       
         
        <Route path="/myproject" element={<Myproject />} />
        <Route path="profil/:id" element={<NavTab />} />
        <Route path="connection/:id" element={<Connection />} />
        <Route path="notification" element={<Notification />} />

        <Route path="university/:acronym" element={<Enseignant />} />
        <Route path="404" element={<NoPage />} />
      </Routes> */}


    </div>
  );
}


export default App;
